import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json' with { type: 'json' };

countries.registerLocale(enLocale);

// Own copy of the i18n-iso-countries convention the bot's own Node-side
// mapping uses — that side is not importable from this Vite/browser build
// target and there's no shared package wiring the two together, so the
// convention is duplicated rather than any component code.

export interface CountryOption {
  value: string;
  label: string;
}

/** The full country list as {value, label} pairs, alpha-2 keyed — this is
 * the only variant the shipping form uses (country-code.ts's
 * normalizeCountryToAlpha2 already resolves any stored alpha-3 to alpha-2
 * before it reaches this form). */
export function getCountryOptions(): CountryOption[] {
  const names = countries.getNames('en', { select: 'official' });
  return Object.entries(names).map(([value, label]) => ({ value, label }));
}

/** Alpha-2 code -> full name, or null if unrecognised. Callers fall back to
 * the raw stored value rather than blanking (unknown/legacy code). */
export function getCountryName(code: string | null | undefined): string | null {
  if (code === null || code === undefined) return null;
  const upper = code.trim().toUpperCase();
  if (upper === '') return null;
  return countries.getName(upper, 'en') ?? null;
}
